import { render, staticRenderFns } from "./PostTimestamp.vue?vue&type=template&id=068caba7&"
import script from "./PostTimestamp.vue?vue&type=script&lang=js&"
export * from "./PostTimestamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports